import { useGoogleAssetsImagesStore } from 'stores/GoogleAssets/GoogleAssetsImagesStore';

export const useImageUploaderDialog = () => {
  const store = useGoogleAssetsImagesStore();

  const handleOpenImageUploaderDialog = () => store.setOpenImageUploaderDialog(true);
  const handleCloseImageUploaderDialog = () => store.setOpenImageUploaderDialog(false);

  return {
    openImageUploaderDialog: store.openImageUploaderDialog,
    handleCloseImageUploaderDialog,
    handleOpenImageUploaderDialog
  };
};
